document.addEventListener("DOMContentLoaded", (event) => {
  ;(function() {
    const selectors = {
      description: '.product-description',
      header: 'h6',
      content: 'p'
    }
    const tabs = [];
    const descriptionElem = document.querySelector(selectors.description);

    const addTab = (header, content) => {
      tabs.push({header, content});
      descriptionElem.removeChild(header);
      descriptionElem.removeChild(content);
    };
    const headers = descriptionElem.querySelectorAll(selectors.header);

    for (const header of headers) {
      
      const contentElem = header.nextElementSibling; 
      const isTab =  contentElem && contentElem.matches(selectors.content);
      if (isTab) addTab(header, contentElem);
    }

    
    const tabsTemplate = document.querySelector('[product-tabify-template]');
    const tabsContainer = tabsTemplate.querySelector('[product-tab-container-template]').cloneNode(false);
    const tabElement = tabsTemplate.querySelector('[product__accordion]');

    let i = 0;
    for (const tab of tabs) {
      const tabElems = tabElement.cloneNode(true);
      tabElems.innerHTML = tabElems.innerHTML.replace(/\$\{index\}/g, i++);

      tabElems.querySelector('.accordion__title').innerHTML = tab.header.innerHTML;
      tabElems.querySelector('.accordion__content').innerHTML = tab.content.innerHTML;
      tabsContainer.append(...tabElems.children);
    }
    descriptionElem.append(tabsContainer);
  })();

});